import {
  Alert,
  Container,
  Row,
  Modal,
  Offcanvas,
  Button,
} from "react-bootstrap";
import React, { useEffect, useState } from "react";
import api from "../seller-apis/api";
import {
  enquiryHistory,
  pendingEnquiries,
  filterenquiry,
  searchenquiryHistory,
  searchnewenquiry,
} from "../seller-apis/apidataField";
import ConfirmationModal from "./common/ConfirmationModal";
import EnquiryCard from "./common/EnquiryCard";
import PopupEnquiry from "./common/PopupEnquiry";
import PaginationCom from "./common/Pagination";
import Popup from "./common/Popup";
import servicesApi from "../seller-apis/servicesApi";
import "./enquiry.css";
import { useAlert } from "react-alert";
import ProductSearch from "./common/ProductSearch";
import { useHistory } from 'react-router-dom';
import { saveVendorStock } from "../services/vendor.service";

var filterList = [];
var datesFromTo = {};
var currTab = "new";

function Enquiry() {
  const history = useHistory();
  var outerdiv;
  var loaderdiv;

  const alert = useAlert();

  // Size states

  // Get the current date
  var currentDate = new Date();

  // Get the date before 15 days
  var before15Days = new Date();
  before15Days.setDate(currentDate.getDate() - 15);

  // Format the dates as strings (optional)
  var currentDateStr = currentDate.toISOString().split('T')[0];
  var before15DaysStr = before15Days.toISOString().split('T')[0];

  const [currView, setcurrView] = useState();

  const [newEnquiriesList, setnewEnquiries] = useState([]);
  const [enquiryHistoryList, setenquiryHistory] = useState([]);
  const [ennewloader, setennewloader] = useState("block");
  const [enhistloader, setenhistloader] = useState("block");
  const [historyRecords, sethistoryRecords] = useState();
  const [newRecords, setnewRecords] = useState();
  const [popuprecordreceived, setpopuprecordreceived] = useState(false);
  const [minValDate, setMinValDate] = useState("");
  const [sortHistdatefrom, setHistsortdatefrom] = useState(before15DaysStr);
  const [sortHistdateto, setHistsortdateto] = useState(currentDateStr);
  const [filterButtonDisabled, setFilterButtonDisabled] = useState(false);

  // Sort Filter States

  const [newSort, setnewSort] = useState();
  const [approvedSort, setapprovedSort] = useState();
  const [dispprovedSort, setdispprovedSort] = useState();
  const [expiredSort, setexpiredSort] = useState();
  const [selectAllSort, setselectAllSort] = useState();
  const [sortdatefrom, setsortdatefrom] = useState(before15DaysStr);
  const [sortdateto, setsortdateto] = useState(currentDateStr);


  //Product Detail Popup

  const [productDetail, setproductDetail] = useState([
    {
      description: undefined,
      sdescription: undefined,
      name: undefined,
      price: undefined,
      SKU: undefined,
      popupVisibility: undefined,
      images: [],
    },
  ]);
  const [isDetailPopupVis, setisDetailPopupVis] = useState("block");
  const [defUrl, setdefUrl] = useState();
  const [currdetprice, setcurrdetprice] = useState("4232");

  const [compforPagination, setcompforPagination] = useState("enquiHistory");
  const [compforPaginationNew, setcompforPaginationNew] =
    useState("newEnquiry");
  const [showfilterHist, setshowfilterHist] = useState(false);

  // Confirmation related
  const [confirmationState, setconfirmationState] = useState(false);
  const [msgConfirmation, setmsgConfirmation] = useState();
  const [selectedenquiry, setselectedenquiry] = useState();
  const [enquiryTo, setenquiryTo] = useState();
  const [selectedenquirypId, setselectedenquirypId] = useState();
  const [selectedenquiryUrl, setselectedenquiryUrl] = useState();
  // Popup

  const [popupData, setpopupData] = useState();
  const [showPopup, setshowPopup] = useState(false);
  const [searchType, setSearchType] = useState("Product Name");
  const [searchHistoryType, setSearchHistoryType] = useState("Product Name");

  // Pagination
  const [newCurrPage, setnewCurrPage] = useState(1);
  const [histcurrPage, sethistcurrPage] = useState(1);

  // Set desktop states for search and sorting

  const [newEnqName, setnewEnqName] = useState("");
  const [oldEnqName, setoldEnqName] = useState();

  const [selectedIndex, setselectedIndex] = useState();

  var dateFromWeb;
  var dateToWeb;
  var datesWeb;
  useEffect(() => {
    if (localStorage.getItem("vendorState") === "partialInactive") {
      history.replace("/home");
      return false;
    }
    let filterEnquiry = {
      pageNo: "1",
      dates: {
        "from-createdAt": sortdatefrom + 'T00:00:00',
        "to-createdAt": sortdateto + 'T23:59:59'
      },
    };
    // New Enquiries
    api.order
      .orders(pendingEnquiries(filterEnquiry))
      .then((res) => {

        setnewEnquiries(res.data);
        setnewRecords(res.totalRecords);
        setennewloader("none");
      })
      .catch((err) => {
        setennewloader("none");
        console.log(err);
      });

    // Enquiry History
    api.order
      .orders(enquiryHistory(filterEnquiry))
      .then((res) => {

        setenquiryHistory(res.data);
        sethistoryRecords(res.totalRecords);
        setenhistloader("none");
      })
      .catch((err) => {
        setenhistloader("none");
      });
  }, []);

  //  Control view acc to size
  function handleResize() {
    if (window.innerWidth > 700) {
      setcurrView("laptop");
    } else {
      setcurrView("mobile");
    }
  }

  function setdateweb(e, type) {
    setFilterButtonDisabled(false);
    dateFromWeb = sortdatefrom;
    dateToWeb = sortdateto;
    if (type === "from") {
      dateFromWeb = e.target.value;
    }
    else {
      dateToWeb = e.target.value;
      // setHistsortdateto(e.target.value)
    }


    if (dateFromWeb != undefined && dateToWeb != undefined) {
      setsortdatefrom(dateFromWeb);
      setsortdateto(dateToWeb);
      let fromDate = new Date(dateFromWeb)
      let toDate = new Date(dateToWeb);
      let diffDate = toDate.getTime() - fromDate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)

      if (daydiffer > 30) {
        setFilterButtonDisabled(true);
        alert.info('Date range cannot be more than 30 days.', { position: 'top center' })
      }
      else if (daydiffer < 0) {
        setFilterButtonDisabled(true);
        alert.info("Please select a valid date range.")
      }
    }
  }
  function sethistorydateweb(e, type) {
    setFilterButtonDisabled(false);
    dateFromWeb = sortdatefrom;
    dateToWeb = sortdateto;
    if (type === "from") {
      dateFromWeb = e.target.value;
    }
    else {
      dateToWeb = e.target.value;
      // setHistsortdateto(e.target.value)
    }

    if (dateFromWeb != undefined && dateToWeb != undefined) {

      setHistsortdatefrom(dateFromWeb);
      setsortdatefrom(dateFromWeb);
      setHistsortdateto(dateToWeb);
      setsortdateto(dateToWeb);
      let fromDate = new Date(dateFromWeb)
      let toDate = new Date(dateToWeb);
      let diffDate = toDate.getTime() - fromDate.getTime()
      let daydiffer = diffDate / (1000 * 60 * 60 * 24);
      daydiffer = Math.floor(daydiffer)

      if (daydiffer > 30) {
        setFilterButtonDisabled(true);
        alert.info('Date range cannot be more than 30 days.', { position: 'top center' })
      }
      else if (daydiffer < 0) {
        setFilterButtonDisabled(true);
        alert.info("Please select a valid date range.")
      }
    }
  }
  function applyFilterHistory() {
    let filterEnquiry = {
      pageNo: "1",
      dates: {
        "from-createdAt": sortdatefrom + 'T00:00:00',
        "to-createdAt": sortdateto + 'T23:59:59'
      },
    };

    api.order
      .orders(enquiryHistory(filterEnquiry))
      .then((res) => {

        setenquiryHistory(res.data);
        sethistoryRecords(res.totalRecords);
        setenhistloader("none");
      })
      .catch((err) => {
        setenhistloader("none");
      });
  }
  function applyFilter() {
    let filterEnquiry = {
      pageNo: "1",
      dates: {
        "from-createdAt": sortdatefrom + 'T00:00:00',
        "to-createdAt": sortdateto + 'T23:59:59'
      },
    };
    api.order
      .orders(pendingEnquiries(filterEnquiry))
      .then((res) => {
        setnewEnquiries(res.data);
        setnewRecords(res.totalRecords);
        setennewloader("none");
      })
      .catch((err) => {
        setennewloader("none");
        console.log(err);
      });
  }

  window.addEventListener("resize", handleResize);

  // Popup showing detail

  function detail(data, price) {

    if (data && data[0] === undefined) {
      setproductDetail([
        {
          description: "No details available",
          sdescription: "No short description",
          name: undefined,
          price: undefined,
          SKU: undefined,
          popupVisibility: undefined,
          images: [],
        },
      ]);
    } else {
      setproductDetail(data);
    }
    setcurrdetprice(price);
  }

  // Pagination

  function paginate(data) {
    let filterData = {
      pageNo: data.number,
    };
    if (sortdatefrom !== undefined || sortdateto !== undefined) {
      filterData['dates'] = {
        "from-createdAt": sortdatefrom + 'T00:00:00',
        "to-createdAt": sortdateto + 'T23:59:59'
      }
    }
    if (data.comp === "newEnquiry") {
      applyLoader("new_enq_table", "enNewLoader", "new");
      setnewCurrPage(data.number);
      setennewloader("block");
      // New Enquiries
      api.order
        .orders(pendingEnquiries(filterData))
        .then((res) => {

          setnewEnquiries(res.data);
          setnewRecords(res.totalRecords);
          removeLoader();
        })
        .catch((err) => {
          removeLoader();
          console.log(err);
          removeLoader();
        });
    } else if (data.comp === "enquiHistory") {
      applyLoader("old_enq_table", "enhistLoader", "old");
      sethistcurrPage(data.number);
      // Enquiry History
      api.order
        .orders(enquiryHistory(filterData))
        .then((res) => {
          setenquiryHistory(res.data);
          sethistoryRecords(res.totalRecords);
          removeLoader();
        })
        .catch((err) => {
          removeLoader();
          console.log(err);
        });
    } else if (data.comp === "filteredEnquiries") {
      sethistcurrPage(data.number);
      if (filterList.length < 1) {
        filterList.push("APPROVED", "DISAPPROVED", "EXPIRED");
      }
      applyLoader("old_enq_table", "enhistLoader", "old");

      // Enquiry History
      if (sortdatefrom === undefined || sortdateto === undefined) {
        api.order
          .orders(filterenquiry(filterData, filterList))
          .then((res) => {
            setenquiryHistory(res.data);
            sethistoryRecords(res.totalRecords);
            removeLoader();
          })
          .catch((err) => {
            console.log(err);
            removeLoader();
          });
      } else {
        api.order
          .orders(filterenquiry(filterData, filterList, datesFromTo))
          .then((res) => {
            setenquiryHistory(res.data);
            sethistoryRecords(res.totalRecords);
            removeLoader();
          })
          .catch((err) => {
            console.log(err);
            removeLoader();
          });
      }
    } else if (data.comp === "newnamesearch") {
      setnewCurrPage(data.number);
      applyLoader("new_enq_table", "ennewLoader", "new");
      api.order
        .orders(searchnewenquiry(filterData, newEnqName))
        .then((res) => {
          if (res.totalRecords > 0) {
            setnewEnquiries(res.data);
            setennewloader("none");
          }
          removeLoader();
        })
        .catch((err) => {
          removeLoader();
          console.log(err);
        });
    } else if (data.comp === "oldnamesearch") {
      sethistcurrPage(data.number);
      applyLoader("old_enq_table", "enhistLoader", "old");
      api.order
        .orders(searchenquiryHistory(filterData, oldEnqName))
        .then((res) => {
          if (res.totalRecords > 0) {
            setenquiryHistory(res.data);
          }
          removeLoader();
        })
        .catch((err) => {
          removeLoader();
          console.log(err);
        });
    }
  }

  // apply loader
  function applyLoader(outer, loader, spcl) {
    outerdiv = document.getElementById("outer");
    loaderdiv = document.getElementById("enNewLoader");
    loaderdiv.classList.add("loader-bt");
    outerdiv.classList.add("div-bk");
    if (spcl === "new") {
      setennewloader("block");
    } else {
      setenhistloader("block");
    }
  }

  function removeLoader() {
    outerdiv.classList.remove("div-bk");
    loaderdiv.classList.remove("loader-bt");
    setenhistloader("none");
    setennewloader("none");
  }

  // Set Sort Filter

  function setSortFilter(value) {
    if (filterList.length > 0) {
      setcompforPagination("filteredEnquiries");
    }
    if (filterList.length === 3) {
      filterList = [];
    }
    let index;
    if (value === "New") {
      if (newSort === true) {
        setnewSort(false);
      } else {
        setnewSort(true);
      }
    } else if (value === "Select All") {
      filterList = [];
      if (selectAllSort === true) {
        setapprovedSort(false);
        setdispprovedSort(false);
        setnewSort(false);
        setexpiredSort(false);
        setselectAllSort(false);
      } else {
        filterList.push("APPROVED");
        filterList.push("DISAPPROVED");
        filterList.push("EXPIRED");
        setapprovedSort(true);
        setdispprovedSort(true);
        setnewSort(true);
        setexpiredSort(true);
        setselectAllSort(true);
      }
    } else if (value === "Approved") {
      if (approvedSort === true) {
        setapprovedSort(false);
        index = filterList.indexOf("APPROVED");
        filterList.splice(index, 1);
      } else {
        filterList.push("APPROVED");
        setapprovedSort(true);
      }
    } else if (value === "Disapproved") {
      if (dispprovedSort === true) {
        setdispprovedSort(false);
        index = filterList.indexOf("DISAPPROVED");
        filterList.splice(index, 1);
      } else {
        setdispprovedSort(true);
        filterList.push("DISAPPROVED");
      }
    } else if (value === "Expired") {
      if (expiredSort === true) {
        setexpiredSort(false);
        index = filterList.indexOf("EXPIRED");
        filterList.splice(index, 1);
      } else {
        filterList.push("EXPIRED");
        setexpiredSort(true);
      }
    }
  }

  // Detail new
  function setpopupVisibilityDetail(e) {
    if (e) {
      setisDetailPopupVis("block");
    } else {
      setisDetailPopupVis("none");
    }
  }
  function clearFilters() {
    applyLoader("old_enq_table", "enhistLoader", "old");
    setcompforPagination("enquiHistory");
    sethistcurrPage(1);
    setselectAllSort(false);
    setapprovedSort(false);
    setdispprovedSort(false);
    setexpiredSort(false);
    setnewSort(false);
    setsortdatefrom();
    setoldEnqName("");
    setsortdateto();
    datesFromTo = {};
    document.getElementById("datefrom").value = "";
    document.getElementById("dateto").value = "";
    filterList = [];
    let filterEnquiry = {
      pageNo: "1",
    };
    api.order
      .orders(enquiryHistory(filterEnquiry))
      .then((res) => {
        removeLoader();
        setenquiryHistory(res.data);
        sethistoryRecords(res.totalRecords);
      })
      .catch((err) => {
        console.log(err);
        removeLoader();
      });
    // setfilterPopupdisplay("none")
    setshowfilterHist(false);
  }

  // Apply sort
  function applySort() {
    applyLoader("old_enq_table", "enhistLoader", "old");
    sethistcurrPage(1);
    setshowfilterHist(false);
    setoldEnqName("");
    if (
      approvedSort === true ||
      dispprovedSort === true ||
      expiredSort === true
    ) {

      let data = {
        pageNo: "1",
      };
      if (sortdatefrom === undefined || sortdateto === undefined) {
        api.order
          .orders(filterenquiry(data, filterList))
          .then((res) => {
            removeLoader();
            setenquiryHistory(res.data);
            sethistoryRecords(res.totalRecords);
            setcompforPagination("filteredEnquiries");
          })
          .catch((err) => console.log(err));
      } else {
        let dates = {
          from: sortdatefrom,
          to: sortdateto,
        };
        datesFromTo = dates;
        api.order
          .orders(filterenquiry(data, filterList, dates))
          .then((res) => {
            setenquiryHistory(res.data);
            sethistoryRecords(res.totalRecords);
            setcompforPagination("filteredEnquiries");
            removeLoader();
          })
          .catch((err) => console.log(err));
      }
    } else if (
      approvedSort === false ||
      dispprovedSort === false ||
      expiredSort === false ||
      sortdatefrom !== undefined ||
      sortdateto !== undefined
    ) {
      filterList.push("APPROVED");
      filterList.push("DISAPPROVED");
      filterList.push("EXPIRED");
      let data = {
        pageNo: "1",
      };
      let dates = {
        from: sortdatefrom,
        to: sortdateto,
      };
      datesFromTo = dates;
      api.order
        .orders(filterenquiry(data, filterList, dates))
        .then((res) => {
          removeLoader();
          setenquiryHistory(res.data);
          sethistoryRecords(res.totalRecords);
          setcompforPagination("filteredEnquiries");
        })
        .catch((err) => console.log(err));
      filterList = [];
    } else {
      setcompforPagination("enquiHistory");
      let filterEnquiry = {
        pageNo: "1",
      };
      api.order
        .orders(enquiryHistory(filterEnquiry))
        .then((res) => {
          removeLoader();
          setenquiryHistory(res.data);
          sethistoryRecords(res.totalRecords);
        })
        .catch((err) => {
          console.log(err);
          removeLoader();
        });
    }
  }

  // Search enquiry function

  // New enquiry

  function searchNewEnq(type = searchType) {
    sethistcurrPage(1);
    let filterEnquiry = {
      pageNo: "1",
    };
    if (
      (newEnqName === "" || newEnqName === undefined) &&
      compforPaginationNew !== "newEnquiry"
    ) {
      applyLoader("new_enq_table", "enNewLoader", "new");
      setcompforPaginationNew("newEnquiry");
      api.order
        .orders(pendingEnquiries(filterEnquiry))
        .then((res) => {
          setnewEnquiries(res.data);
          setnewRecords(res.totalRecords);
          removeLoader();
        })
        .catch((err) => {
          console.log(err);
          removeLoader();
        });
    } else if (newEnqName !== "" && newEnqName !== undefined) {
      applyLoader("new_enq_table", "enNewLoader", "new");
      setcompforPaginationNew("newnamesearch");
      api.order
        .orders(searchnewenquiry(filterEnquiry, newEnqName, type))
        .then((res) => {
          removeLoader();
          setnewEnquiries(res.data);
          setnewRecords(res.totalRecords);
        })
        .catch((err) => {
          removeLoader();
          console.log(err);
        });
    }
  }

  // Enquiry History

  function searchEnquiry() {
    sethistcurrPage(1);
    let filterEnquiry = {
      pageNo: "1",
    };

    if (
      (oldEnqName === "" || oldEnqName === undefined) &&
      compforPagination !== "enquiHistory"
    ) {
      applyLoader("old_enq_table", "enhistLoader", "old");
      setcompforPagination("enquiHistory");
      api.order
        .orders(enquiryHistory(filterEnquiry))
        .then((res) => {
          removeLoader();
          setenquiryHistory(res.data);
          sethistoryRecords(res.totalRecords);
        })
        .catch((err) => { });
    } else if (oldEnqName !== "" && oldEnqName !== undefined) {
      setcompforPagination("oldnamesearch");
      applyLoader("old_enq_table", "enhistLoader", "old");
      api.order
        .orders(searchenquiryHistory(filterEnquiry, oldEnqName, searchHistoryType))
        .then((res) => {
          removeLoader();
          setenquiryHistory(res.data);
          sethistoryRecords(res.totalRecords);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  // Confirmation Modal

  function confirmationBoxHiding(state) {
    if (state === false) {
      setconfirmationState(false);
    }
  }

  // Update enquiries

  function approveEnquiry(e, rType, pId, selSubPrdValObj, index) {
    setselectedIndex(index)
    setselectedenquiry(e);
    setenquiryTo("approve");
    //Sl-699
    setselectedenquirypId(pId);
    setselectedenquiryUrl(selSubPrdValObj && selSubPrdValObj != null
      && selSubPrdValObj != undefined ? selSubPrdValObj.url : null);
    setmsgConfirmation("Are you sure you want to approve this product ?");
    setconfirmationState(true);


  }

  function disapproveEnquiry(e) {
    setenquiryTo("disapprove");
    setselectedenquiry(e);
    setmsgConfirmation("Are you sure you want to disapprove this product ?");
    setconfirmationState(true);
  }

  function setpopupVisibilityDetail(e) {
    if (e) {
      setisDetailPopupVis("block");
    } else {
      setisDetailPopupVis("none");
    }
  }

  // Confirmation Response

  function responseConfirmationEnquiry(response, id, stock) {
    if (enquiryTo === "approve") {
      if (response === "yes") {
        let filterEnquiry = {
          pageNo: newCurrPage,
        };
        let filterenquiryhist = {
          pageNo: "1",
        };
        let data = {
          _id: id,
          status: "APPROVED",
        };
        api.order
          .updateOrder(data)
          .then((res) => {
            if (res.message === "record updated") {
              alert.success("Record updated");
              updateSellerStock(selectedenquirypId, selectedenquiryUrl, Number(stock));
              setTimeout(() => {
                api.order
                  .orders(pendingEnquiries(filterEnquiry))
                  .then((res) => {
                    setnewEnquiries(res.data);
                    setnewRecords(res.totalRecords);
                    setconfirmationState(false);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
                api.order
                  .orders(enquiryHistory(filterenquiryhist))
                  .then((res) => {
                    setenquiryHistory(res.data);
                    sethistoryRecords(res.totalRecords);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }, 500);
            }
          })
          .catch((err) => console.log(err));
      }
    } else if (enquiryTo === "disapprove") {
      if (response === "yes") {
        let filterEnquiry = {
          pageNo: newCurrPage,
        };
        let filterenquiryhist = {
          pageNo: "1",
        };
        let data2 = {
          _id: id,
          status: "DISAPPROVED",
        };
        api.order
          .updateOrder(data2)
          .then((res) => {

            if (res.message === "record updated") {
              alert.success("Record updated");
              setTimeout(() => {
                api.order
                  .orders(pendingEnquiries(filterEnquiry))
                  .then((res) => {
                    setnewEnquiries(res.data);
                    setnewRecords(res.totalRecords);
                    setconfirmationState(false);
                  })
                  .catch((err) => {
                    setennewloader("none");
                    console.log(err);
                  });
                api.order
                  .orders(enquiryHistory(filterenquiryhist))
                  .then((res) => {
                    setenquiryHistory(res.data);
                    sethistoryRecords(res.totalRecords);
                  })
                  .catch((err) => {
                    setennewloader("none");
                    console.log(err);
                  });
              }, 500);
            }
          })
          .catch((err) => console.log(err));
      }
    }
  }

  //SL-699 : Seller Stock Update
  function updateSellerStock(id, url, stock) {

    // l1-2341 (26-9-25)
    let stockStatus = (Number(stock) > 0) ? "In Stock" : "Out Of Stock"

    let data = {
      "_id": id,
      "stock": stock,
      "vActive": "ACTIVE",
      "reason": ""
    }
    //if given 0, then out of stock
    if (stock == 0) {
      data["vActive"] = "INACTIVE";
      data["reason"] = "Out Of Stock";
      handleSaveVendorStock(stockStatus, stock);
    }
    else if (newEnquiriesList[selectedenquiry]?.stock > 0 && (Number(newEnquiriesList[selectedenquiry]?.stock) < 1) && Number(stock) > 0) {
      handleSaveVendorStock(stockStatus, stock);
    }
    else if ((Number(newEnquiriesList[selectedenquiry]?.stock) < 1 && Number(stock) > 0) || !newEnquiriesList[selectedenquiry]?.stock) {
      handleSaveVendorStock(stockStatus, stock);
    }


    if (url !== undefined && url !== null)
      data["url"] = url;
    //Uncommented api call | Ticket : SL-996
    api.product.addToExProduct(data).then((res) => {

    }).catch(err => console.log(err))


  }


  //   Popup related functions

  function setpopupVisibility(e, popupInfo) {
    if (e === "2") {
      setpopupData(popupInfo);
      setshowPopup(true);
      setpopuprecordreceived(true);
    } else {
      setshowPopup(false);
    }
  }

  // search order for web on enter

  function checkevent(e, name) {
    if (e.keyCode === 13) {
      let filterEnquiry = {
        pageNo: "1",
      };
      if (name === "newEnq" && newEnqName !== "") {
        applyLoader("new_enq_table", "enNewLoader", "new");
        setnewCurrPage(1);
        let j = newEnqName.trim();
        setnewEnqName(newEnqName.trim());

        api.order
          .orders(searchnewenquiry(filterEnquiry, j))
          .then((res) => {
            removeLoader();
            setnewEnquiries(res.data);
            setnewRecords(res.totalRecords);
            setcompforPaginationNew("newnamesearch");
          })
          .catch((err) => {
            console.log(err);
            removeLoader();
          });
      } else if (name === "newEnq" && newEnqName === "") {
        setnewCurrPage(1);
        applyLoader("new_enq_table", "enNewLoader", "new");
        setcompforPaginationNew("newEnquiry");
        api.order
          .orders(pendingEnquiries(filterEnquiry))
          .then((res) => {
            setnewEnquiries(res.data);
            setnewRecords(res.totalRecords);
            removeLoader();
          })
          .catch((err) => {
            removeLoader();
            console.log(err);
          });
      } else if (name === "oldEnq" && oldEnqName !== "") {
        sethistcurrPage(1);
        setselectAllSort(false);
        setapprovedSort(false);
        setdispprovedSort(false);
        setexpiredSort(false);
        setnewSort(false);
        setsortdatefrom();
        setoldEnqName("");
        setsortdateto();
        filterList = [];
        datesFromTo = {};
        applyLoader("old_enq_table", "enhistLoader", "old");
        let j = oldEnqName.trim();
        setoldEnqName(oldEnqName.trim());
        api.order
          .orders(searchenquiryHistory(filterEnquiry, oldEnqName))
          .then((res) => {
            setenquiryHistory(res.data);
            sethistoryRecords(res.totalRecords);
            setcompforPagination("oldnamesearch");
            removeLoader();
          })
          .catch((err) => {
            console.log(err);
            removeLoader();
          });
      } else if (name === "oldEnq" && oldEnqName === "") {
        sethistcurrPage(1);
        setselectAllSort(false);
        setapprovedSort(false);
        setdispprovedSort(false);
        setexpiredSort(false);
        setnewSort(false);
        setsortdatefrom();
        setoldEnqName("");
        setsortdateto();
        datesFromTo = {};
        filterList = [];
        applyLoader("old_enq_table", "enhistLoader", "old");
        setcompforPagination("enquiHistory");
        api.order
          .orders(enquiryHistory(filterEnquiry))
          .then((res) => {
            setenquiryHistory(res.data);
            sethistoryRecords(res.totalRecords);
            removeLoader();
          })
          .catch((err) => {
            console.log(err);
            removeLoader();
          });
      }
    }
  }

  const handleCloseFiltHist = () => setshowfilterHist(false);
  const handleShowFiltHist = () => setshowfilterHist(true);

  function clickTabs() {
    let filterEnquiry = {
      pageNo: "1",
    };
    if (currTab === "old") {
      setoldEnqName("");
      if (compforPagination !== "enquiHistory") {
        sethistcurrPage(1);
        setcompforPagination("enquiHistory");

        setselectAllSort(false);
        setapprovedSort(false);
        setdispprovedSort(false);
        setexpiredSort(false);
        setnewSort(false);
        setsortdatefrom();
        setoldEnqName("");
        setsortdateto();
        datesFromTo = {};
        document.getElementById("datefrom").value = "";
        document.getElementById("dateto").value = "";
        filterList = [];
        // Enquiry History
        api.order
          .orders(enquiryHistory(filterEnquiry))
          .then((res) => {

            setenquiryHistory(res.data);
            sethistoryRecords(res.totalRecords);
            setenhistloader("none");
          })
          .catch((err) => {
            setenhistloader("none");
          });
      }

      currTab = "new";
    } else {
      setnewEnqName("");
      if (compforPaginationNew !== "newEnquiry") {
        setnewCurrPage(1);
        setcompforPaginationNew("newEnquiry");
        api.order
          .orders(pendingEnquiries(filterEnquiry))
          .then((res) => {

            setnewEnquiries(res.data);
            setnewRecords(res.totalRecords);
            setennewloader("none");
          })
          .catch((err) => {
            setennewloader("none");
            console.log(err);
          });
      }
      currTab = "old";
    }
  }
  const filterSearch = (data) => {
    setnewEnqName(data.data);
    setSearchType(data.type)
  }
  useEffect(() => {
    // alert.success(newEnqName);
    if (newEnqName != "") {
      checkevent({ "keyCode": 13 }, "newEnq");
    }
  }, [newEnqName])


  // l1-2341 (26-9-25)
  const handleSaveVendorStock = async (stockStatus, stockVal) => {
    const selectedTicket = newEnquiriesList[selectedIndex];
    const selectedUrls = selectedenquiryUrl;
    
    try {
      let data = {
        "product": selectedTicket?.product?._id ? selectedTicket?.product?._id : selectedTicket?.product,//SL-1068
        "vendor": localStorage.getItem("vendorId"),
        "taxClass": selectedTicket?.taxClass || selectedTicket?.order?.products?.[0]?.taxClass || null,//SL-1068
        "purchase_price": selectedTicket?.price || selectedTicket?.purchase_price || 0,//SL-1068
        "stock": stockVal,
        "status": "AUTOAPPROVED",
        "stockStatus": stockStatus,
        "site_price": selectedTicket?.specialPrice ? selectedTicket?.specialPrice : selectedTicket?.purchase_price,
        "categories": selectedTicket?.categories,
        ...(selectedTicket?.combination?.url && { "combination.url": selectedUrls }),
        "receivedFrom": "seller"
      }
      const res = await saveVendorStock(data)
    } catch (err) {
      console.log(err)
      alert.error(err.message || "Failed to update stock status");
      // Re-throw the error so the calling function knows it failed
      throw err;
    }
  }

  return (
    <>
      <div className="container" id="outer">
        <div class="tab-frame gry-line">
          <input
            type="radio"
            defaultChecked
            name="tab"
            id="tab1"
            className="tab-input enquiry_tab_opt"
            onClick={() => clickTabs()}
          />
          <label
            for="tab1"
            className="w-40  tab-label-input ff_pop float-left me-2"
          >
            New Enquiries ({newRecords})
          </label>

          <input
            type="radio"
            name="tab"
            id="tab2"
            className="tab-input enquiry_tab_opt"
            onClick={() => clickTabs()}
          />
          <label for="tab2" className="w-40  tab-label-input ff_pop">
            Enquiry History ({historyRecords})
          </label>

          {/* New enquiries tab destop */}
          <div class="tab">
            {/* Filter */}
            <div className=" bg-white py-2">
              <div className='d-flex mb-3 justify-content-start'>
                {/* ******** */}
                <div className='theme-shed1 p-0'>
                  <div className='m-auto mt-1'>
                    <span className='payment_dates'>From: - <input type='date' min={minValDate} value={sortdatefrom} onChange={(e) => setdateweb(e, "from")}></input></span>
                    <span className='mx-2 payment_dates'>To: - <input type='date' value={sortdateto} onChange={(e) => setdateweb(e, "to")}></input></span>
                    <span><button disabled={filterButtonDisabled} className='apply-btn px-3 py-1 ff_Pop fs-14' onClick={() => applyFilter()}>Apply</button></span>
                    {/* <span><button className={`payment_btn_export px-3 py-1 ff_Pop fs-14 ms-1 ${removeFilterClass}`} onClick={() => clearFilters()}>Clear</button></span> */}
                  </div>
                </div>
                {/* ****** */}
              </div>
              {/* <div className="d-flex w-30 float-right main mb-2">
                <input
                  type="text"
                  name="input"
                  className="input1 ff_pop"
                  value={newEnqName}
                  placeholder="Search Something....."
                  onChange={(e) => setnewEnqName(e.target.value)}
                  onKeyUp={(e) => checkevent(e, "newEnq")}
                />
                <div className="icon" onClick={() => searchNewEnq()}>
                  <i className="fa fa-search " aria-hidden="true"></i>
                </div>
              </div> */}
            </div>
            <div className="table-responsive">
              <table
                className="ord_table"
                style={{ width: "100%" }}
                id="new_enq_table"
              >
                <thead>
                  <tr className="table_ord_title_row">
                    <th className="thead_title" style={{ width: "10%" }}>
                      Enquiry ID
                    </th>

                    <th className="thead_title pb-1" style={{ width: "12%" }}>
                      Date<br></br>
                    </th>

                    <th className="thead_title" style={{ width: "10%" }}>
                      Product image
                    </th>

                    <th className="thead_title" style={{ width: "20%" }}>
                      Product Name

                      {/* <input type="text"
                    value={newEnqName}
                    placeholder="Search ..."
                    onChange={(e) => setnewEnqName(e.target.value)}
                    onKeyUp={(e) => checkevent(e, "newEnq")} />
                      <button type="button"  onClick={() => searchNewEnq()}><i class="fa fa-search"></i></button> */}
                      {/* <ProductSearch 
                      filterSearch={filterSearch}
                      searchNewEnq={searchNewEnq}
                      /> */}
                    </th>

                    <th className="thead_title" style={{ width: "7%" }}>
                      Transfer price
                    </th>

                    <th className="thead_title" style={{ width: "19%" }}>
                      Action required
                    </th>
                  </tr>
                </thead>

                {newEnquiriesList.length > 0 ? (
                  <tbody>
                    {newEnquiriesList.map((item, index) => {
                      let baseImg;
                      let date = new Date(item.createdAt);
                      let d = date.toUTCString(item.createdAt);
                      let newd = d.substr(4, 12);
                      if (item?.order?.products && item?.order?.products?.length > 0) {
                        if (
                          item.order.products.length > 0 &&
                          item.order.products[0].selSubPrd &&
                          item.order.products[0].productId.combination
                        ) {
                          item?.order?.products[0]?.productId?.images.map((item) => {
                            if (item.baseImage === true) {
                              if (item.image.startsWith("products")) {
                                baseImg = item.image;
                              } else if (item.image.startsWith("mob")) {
                                baseImg = item.image;
                              } else {
                                var img = item.image.substr("41");
                                baseImg = img;
                              }
                            }
                          });
                          return (
                            <EnquiryCard
                              date={newd}
                              id={index}
                              productId={item._id}
                              image={baseImg}
                              enquiryId={item.order.orderId}
                              productName={
                                item.order?.products[0]?.productId?.productName
                              }
                              SKU={
                                item.order?.products[0]?.productId?.SKU
                              }
                              taxClass={item.order?.products[0]?.productId?.taxClass}
                              urlKey={item.order?.products[0]?.productId?.urlKey}
                              price={item.purchase_price}
                              quantity={item.order?.products[0]?.quantity}
                              status={item.status}
                              selSubPrdVal={
                                item.order?.products[0]?.selSubPrd?.value
                              }
                              combination={
                                item.order?.products[0]?.productId?.combination[0]?.value
                              }
                              popupVisibility={setpopupVisibility}
                              approve={approveEnquiry}
                              pdetail={detail}
                              disapprove={disapproveEnquiry}
                              popupdetailVis={setpopupVisibilityDetail}
                              pId={item.order.products[0].productId._id}
                              selSubPrdValObj={item.order?.products[0]?.selSubPrd}

                            />
                          );
                        } else {
                          item.order.products[0].productId.images.map((item) => {
                            if (item.baseImage === true) {
                              if (item.image.startsWith("products")) {
                                baseImg = item.image;
                              } else {
                                let img = item.image.substr("41");
                                baseImg = img;
                              }
                            }
                          });
                          return (
                            <EnquiryCard
                              date={newd}
                              id={index}
                              productId={item._id}
                              image={baseImg}
                              taxClass={item.order.products[0]?.productId?.taxClass}
                              enquiryId={item.order.orderId}
                              productName={
                                item.order.products[0]?.productId?.productName
                              }
                              SKU={
                                item.order?.products[0]?.productId?.SKU
                              }
                              urlKey={item.order?.products[0]?.productId?.urlKey}
                              price={item.purchase_price}
                              quantity={item.order?.products[0]?.quantity}
                              status={item.status}
                              pdetail={detail}
                              popupVisibility={setpopupVisibility}
                              popupdetailVis={setpopupVisibilityDetail}
                              approve={approveEnquiry}
                              disapprove={disapproveEnquiry}
                              pId={item.order?.products[0]?.productId._id}

                            />
                          );
                        }
                      } else {
                        return (
                          <EnquiryCard
                            date={newd}
                            id={index}
                            enquiryId={item?.order?.orderId}
                            spcl="noProDetail"
                          />
                        );
                      }
                    })}
                  </tbody>
                ) : ennewloader === "block" ? (
                  <></>
                ) : (
                  <tbody className="text-center ">
                    <td colSpan={6}>No New Enquiries</td>
                  </tbody>
                )}
              </table>
            </div>
            <div class="d-flex justify-content-center" id="enNewLoader">
              <div
                class="spinner-border"
                role="status"
                style={{ display: ennewloader }}
              >
                <span class="sr-only"></span>
              </div>
            </div>

            <PaginationCom
              number={newRecords}
              paginate={paginate}
              activ={newCurrPage}
              comp={compforPaginationNew}
            />
          </div>

          {/* History  tab desktop*/}
          <div class="tab">
            <div className=" bg-white py-2">
              <div className='d-flex mb-3 justify-content-start'>
                {/* ******** */}
                <div className='theme-shed1 p-2'>
                  <div className='m-auto mt-1'>
                    <span className='payment_dates'>From: - <input type='date' min={minValDate} value={sortHistdatefrom} onChange={(e) => sethistorydateweb(e, "from")}></input></span>
                    <span className='mx-2 payment_dates'>To: - <input type='date' value={sortHistdateto} onChange={(e) => sethistorydateweb(e, "to")}></input></span>
                    <span><button className='apply-btn px-3 py-1 ff_Pop fs-14' onClick={() => applyFilterHistory()}>Apply</button></span>
                    {/* <span><button className={`payment_btn_export px-3 py-1 ff_Pop fs-14 ms-1 ${removeFilterClass}`} onClick={() => clearFilters()}>Clear</button></span> */}
                  </div>
                </div>
                {/* ****** */}
              </div>
              <div className="d-flex w-40 float-right mb-2">
                <div className="d-flex w-80">

                  {/* <input
                    type="text"
                    name="input"
                    value={oldEnqName}
                    className="input1 ff_pop"
                    placeholder="Search Something....."
                    onChange={(e) => setoldEnqName(e.target.value)}
                    onKeyUp={(e) => checkevent(e, "oldEnq")}
                  />
                  <div className="icon" onClick={() => searchEnquiry()}>
                    <i className="fa fa-search " aria-hidden="true"></i>
                  </div> */}
                </div>
                <div className=" col-3 theme-col pt-2 fs-14 ff_pop">
                  {" "}
                  Filter{" "}
                  <a className="button" onClick={() => handleShowFiltHist()}>
                    {" "}
                    <i
                      className="fa fa-sort-amount-desc theme-col pl-1"
                      aria-hidden="true"
                    ></i>
                  </a>
                </div>
                {/* New popup */}
              </div>
              <Modal
                className="modalenFilt"
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={showfilterHist}
                onHide={handleCloseFiltHist}
              >
                <Modal.Header closeButton>
                  <p className="m-auto">
                    <i class="bi bi-funnel-fill fs-30 m_l-15 text-primary"></i>
                  </p>
                </Modal.Header>
                <Modal.Body>
                  <form action="/action_page.php" className="fs-14 f-500 mt-3">
                    <input
                      type="checkbox"
                      id="vehicle1"
                      checked={selectAllSort}
                      name="vehicle1"
                      value="Select All"
                      className="mt-2"
                      onChange={() => setSortFilter("Select All")}
                    />
                    <label for="vehicle1" className="pl-1">
                      {" "}
                      Select All
                    </label>
                    <br></br>
                    {/* <input type="checkbox" id="vehicle2" checked={newSort} name="vehicle2" value="New" className="mt-3" onChange={() => setSortFilter("New")} />
                      <label for="vehicle2" className="pl-1"> New</label><br></br> */}
                    <input
                      type="checkbox"
                      id="vehicle3"
                      checked={approvedSort}
                      name="vehicle3"
                      value="Approved"
                      className="mt-2"
                      onChange={() => setSortFilter("Approved")}
                    />
                    <label for="vehicle3" className="pl-1">
                      {" "}
                      Approved
                    </label>
                    <br></br>
                    <input
                      type="checkbox"
                      id="vehicle4"
                      checked={dispprovedSort}
                      name="vehicle3"
                      value="Disapproved"
                      className="mt-2"
                      onChange={() => setSortFilter("Disapproved")}
                    />
                    <label for="vehicle4" className="pl-1">
                      {" "}
                      Disapproved
                    </label>
                    <br></br>
                    <input
                      type="checkbox"
                      id="vehicle5"
                      checked={expiredSort}
                      name="vehicle4"
                      value="Expired"
                      className="mt-2"
                      onChange={() => setSortFilter("Expired")}
                    />
                    <label for="vehicle5" className="pl-1">
                      {" "}
                      Expired
                    </label>
                    <br></br>
                  </form>
                  <Row className="mt-3">
                    <div className="col-9 fs-14 f-500">Filter by date</div>
                    <div className="col-3">
                      {/* <button className="clr" onClick={() => clearFilters()}>
                        Clear
                      </button> */}
                    </div>
                  </Row>
                  <Row className="mt-3">
                    <div className="col-6">
                      <form>
                        <input
                          className="w-100 in-put filt_date_Sect"
                          type="date"
                          id="datefrom"
                          name="name"
                          value={sortdatefrom}
                          onChange={(e) => setsortdatefrom(e.target.value)}
                          placeholder="Start date"
                        />
                      </form>
                    </div>
                    <div className="col-6">
                      <form>
                        <input
                          className="w-100 in-put filt_date_Sect"
                          type="date"
                          id="dateto"
                          name="name"
                          value={sortdateto}
                          onChange={(e) => setsortdateto(e.target.value)}
                          placeholder="End date"
                        />
                      </form>
                    </div>
                  </Row>
                  <Row className="mt-4 mb-2">
                    <div className="col-6">
                      <button className="cl" onClick={handleCloseFiltHist}>
                        Cancel
                      </button>
                    </div>
                    <div className="col-6">
                      <button
                        className="al apply_btn_filter"
                        onClick={() => applySort()}
                      >
                        Apply
                      </button>
                    </div>
                  </Row>
                </Modal.Body>
              </Modal>
            </div>
            <div className="table-responsive">
              <table
                className="ord_table"
                style={{ width: "100%" }}
                id="old_enq_table"
              >
                <thead>
                  <tr className="table_ord_title_row">
                    <th className="thead_title" style={{ width: "10%" }}>
                      Enquiry ID
                    </th>

                    <th className="thead_title pb-1" style={{ width: "12%" }}>
                      Date<br></br>
                    </th>

                    <th className="thead_title" style={{ width: "10%" }}>
                      Product image
                    </th>

                    <th className="thead_title" style={{ width: "20%" }}>
                      Product Name
                      {/* <div class="search-container">
                    <select onChange={(e)=>{setSearchHistoryType(e.target.value)}}>
                        <option value="product Name">Product Name</option>
                        <option value="sku">SKU</option>
                      </select>
                    </div>
                    <div class="search-container">
                      <input type="text"
                    value={oldEnqName}
                    className="input1 ff_pop"
                    placeholder="Search..."
                    onChange={(e) => setoldEnqName(e.target.value)}
                    onKeyUp={(e) => checkevent(e, "oldEnq")} />
                      <button type="button"  onClick={() => searchEnquiry()}><i class="fa fa-search"></i></button>
                    </div> */}
                    </th>

                    <th className="thead_title" style={{ width: "10%" }}>
                      Transfer price
                    </th>

                    <th className="thead_title" style={{ width: "15%" }}>
                      Your response
                    </th>
                  </tr>
                </thead>

                {enquiryHistoryList.length > 0 ? (
                  <tbody>
                    {enquiryHistoryList.map((item, index) => {
                      let baseImg;
                      let date = new Date(item.createdAt);
                      let d = date.toUTCString(item.createdAt);
                      let newd = d.substr(4, 12);
                      item?.order?.products[0]?.productId?.images.map((item) => {
                        if (item.baseImage === true) {
                          if (item.image.startsWith("products")) {
                            baseImg = item.image;
                          } else if (item.image.startsWith("mob")) {
                            baseImg = item.image;
                          } else {
                            var img = item.image.substr("41");
                            baseImg = img;
                          }
                        }
                      });
                      if (item?.order?.products && item?.order?.products?.length > 0) {
                        if (
                          item.order.products.length > 0 &&
                          item.order?.products[0]?.selSubPrd &&
                          item.order.products[0]?.productId?.combination
                        ) {
                          return (
                            <EnquiryCard
                              id={index}
                              date={newd}
                              image={baseImg}
                              enquiryId={item.order.orderId}
                              taxClass={item.order.products[0]?.productId?.taxClass}
                              urlKey={item.order.products[0]?.productId?.urlKey}
                              productName={
                                item.order.products[0]?.productId?.productName
                              }
                              price={item.purchase_price}
                              quantity={item.order?.products[0]?.quantity}
                              selSubPrdVal={
                                item.order?.products[0]?.selSubPrd?.value
                              }
                              combination={
                                item.order?.products[0]?.productId?.combination[0]?.value
                              }
                              status={item.status}
                              pdetail={detail}
                              popupdetailVis={setpopupVisibilityDetail}
                              popupVisibility={setpopupVisibility}
                            />
                          );
                        } else {
                          return (
                            <EnquiryCard
                              id={index}
                              date={newd}
                              image={baseImg}
                              enquiryId={item.order.orderId}
                              taxClass={item.order?.products[0]?.productId?.taxClass}
                              urlKey={item.order?.products[0]?.productId?.urlKey}
                              productName={
                                item.order?.products[0]?.productId?.productName
                              }
                              price={item.purchase_price}
                              quantity={item.order?.products[0]?.quantity}
                              status={item.status}
                              pdetail={detail}
                              popupdetailVis={setpopupVisibilityDetail}
                              popupVisibility={setpopupVisibility}
                            />
                          );
                        }
                      }
                    })}
                  </tbody>
                ) : enhistloader == "block" ? (
                  <></>
                ) : (
                  <tbody className="text-center ">
                    <td colSpan={6}>No History</td>
                  </tbody>
                )}
              </table>
            </div>
            <div class="d-flex justify-content-center" id="enhistLoader">
              <div
                class="spinner-border"
                role="status"
                style={{ display: enhistloader }}
              >
                <span class="sr-only"></span>
              </div>
            </div>

            <PaginationCom
              number={historyRecords}
              activ={histcurrPage}
              paginate={paginate}
              comp={compforPagination}
            />
          </div>
        </div>

        {/* Confirmation Modal */}
        <Modal
          show={confirmationState}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <ConfirmationModal
            onHide={confirmationBoxHiding}
            selectedId={selectedenquiry}
            msg={msgConfirmation}
            enquiryTo={enquiryTo}
            responseconfirmationFun={responseConfirmationEnquiry}
            from="enquiry"
          />
        </Modal>
      </div>

      {/* Detail new Popup*/}

      <div
        id="popupDetail"
        className="overlay"
        style={{ display: isDetailPopupVis }}
      >
        <Popup
          from="newOrder"
          description={productDetail[0].description}
          sdescription={productDetail[0]?.shortDescription}
          descriptionNew={productDetail[0]?.descriptionNew}
          specificationNew={productDetail[0].specificationNew}
          name={productDetail[0].productName}
          // price={productDetail[0].price}
          price={currdetprice}
          SKU={productDetail[0].SKU}
          popupVisibility={setpopupVisibilityDetail}
          images={productDetail[0].images}
        />
      </div>
    </>
  );
}

export default Enquiry;
